import * as Sentry from '@sentry/react'
import { RouterProvider } from 'react-router'
import { Toaster } from 'sonner'
import { router } from '@/app/routers';

export function App() {
  return (
    <>
      <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}>
        <RouterProvider router={router} />
      </Sentry.ErrorBoundary>
      <Toaster position="bottom-right" richColors closeButton />
    </>
  )
}